
import { call, put, takeLatest, select } from 'redux-saga/effects';
import safeSaga from '../safeSaga';
import { REMOVE_UPLOADED_IMAGE,
  REMOVE_UPLOAD_IMAGE_SUCCESS,
  REMOVE_IMAGE_LOADING,
  REMOVE_UPLOAD_IMAGE_ERROR_INFO } from '../../actions/actionTypes';
import { removeImagesFromS3 } from '../../api/removeImageApi';
import { updateAddToBundleDisabled } from '../../actions/configAction';
import { uploadImagesSelector } from '../../selectors';
import { updatePath } from '../../actions/pathActions';
import getExpConfig from '../../utils/getExpConfig';

function* removeImageSaga(action) {
  const {
    uploadImagesUrl,
  } = yield select(uploadImagesSelector);
  const payload = {
    id: action.payload.id,
    logoPosition: action.payload.logoPosition,
    fileName: null,
    file: null,
    showUploadRemoveButton: false,
    enableRemoveBackground: false,
    toggleRemoveBackground: false,
    isImageLoading: false,
    uploadImagesUrl,
    logoColors: 1,
  };
  const errorpayload = {
    id: action.payload.id,
    isImageLoading: false,
    uploadImageErrorMessage: 'Sorry, something went wrong. Please try again.',
    showUploadImageError: true,
  };
  try {
    const params = {
      fileName: action.payload.fileName,
      lineItemId: action.payload.lineItemId,
      uploadType: `${getExpConfig('amazon-s3-environment-path')}Local`,
      logoPosition: action.payload.logoPosition,
    };

    const response = yield call(removeImagesFromS3, params);
    if (response.status === 200) {
      yield put({ type: REMOVE_UPLOAD_IMAGE_SUCCESS, payload });
      yield put(updateAddToBundleDisabled({ isAddtoBundleDisabled: false }));
      yield put(updatePath());
    } else {
      yield put({ type: REMOVE_UPLOAD_IMAGE_SUCCESS, payload });
      yield put({ type: REMOVE_IMAGE_LOADING, errorpayload });
      yield put({ type: REMOVE_UPLOAD_IMAGE_ERROR_INFO, errorpayload });
    }
  } catch (error) {
    yield put({ type: REMOVE_UPLOAD_IMAGE_SUCCESS, payload });
    yield put({ type: REMOVE_IMAGE_LOADING, errorpayload });
    yield put({ type: REMOVE_UPLOAD_IMAGE_ERROR_INFO, errorpayload });
  }
}
export default function* reoveImageSaga() {
  yield takeLatest(REMOVE_UPLOADED_IMAGE, safeSaga(removeImageSaga));
}
